module.exports = __webpack_public_path__ + "img/card-hz.e97aa292.png";